import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const DemandWiseOrder = () => {
  const { id } = useParams();
  const [receiveData, setReceiveData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await Http.get(`/demand-wise-order/${id}`);
        setReceiveData(res.data);
      } catch (e) {
        console.error("Fetch error:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const cols = [
    { field: "receipt_no", header: "Invoice No" },
    { field: "date", header: "Date" },
    { field: (item) => (item.distributor ? item.distributor.name : ""), header: "Distributor" },
    { field: "total_price", header: "Invoice Total" },
    { field: "payment_type", header: "Payment Type" },
  ];

  const actionTemplate = (item) => (
    <td className="text-right">
      <Link to={"/primary-sales-detail/" + item.id} className="btn btn-info btn-sm" title="View Details">
        <i className="fa fa-eye"></i>
      </Link>
    </td>
  );

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Demand Wise Orders</h5>
          <Link to="/demand-sheet" className="btn btn-secondary">
            <i className="fa fa-arrow-left mg-r-6"></i> Back to List
          </Link>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <ReactDataTable cols={cols} receiveData={receiveData} isLoading={loading} actionTemplate={actionTemplate} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemandWiseOrder;
